import React from "react";
import Navbar from "./Navbar/Navbar";
import "./Funders.css";

const funders = [
  {
    name: "AIC STPINEXT Initiatives",
    type: "Startup Incubation & Support",
    date: "2023",
    description:
      "AIC STPINEXT Initiatives is a leading startup incubator under STPI, supporting early-stage startups with mentoring, networking, and funding opportunities.",
  },
  {
    name: "Indian Statistical Institute, Kolkata",
    type: "Research Collaboration & Funding",
    date: "2023",
    description:
      "The Indian Statistical Institute, Kolkata, has supported IQApex Labs with research collaboration and innovation grants for advanced data-driven solutions.",
  },
  {
    name: "Government of Karnataka",
    type: "Efficiency Augmentation Program",
    date: "2024",
    description:
      "The Government of Karnataka provided funding under its Efficiency Augmentation program, enabling IQApex Labs to enhance technology-driven efficiency solutions.",
  },
  {
    name: "Octane Program, Software Technology Parks of India (STPI)",
    type: "Startup Program Support",
    date: "2024",
    description:
      "The STPI Octane Program supports startups in technology and innovation. Their funding and mentorship accelerated IQApex Labs’ product development and outreach.",
  },
  {
    name: "U2CA Consultancy.",
    type: "Private Investment & Mentorship",
    date: "2024",
    description:
      "V2CA Consultants Pvt. Ltd., Gurgaon, Haryana, invested in IQApex Labs with financial and strategic advisory support to scale operations.",
  },
  {
    name: "Apiary, Government of Haryana – CoE in Blockchain Technology",
    type: "Blockchain Innovation Grant",
    date: "2025",
    description:
      "Apiary, an initiative of the Government of Haryana, provided blockchain-focused funding and incubation support through its Centre of Excellence.",
  },
  {
    name: "BUZZARIA INDIA PRIVATE LIMITED",
    type: "Private Investment & Partnership",
    date: "2025",
    description:
      "BUZZARIA INDIA PRIVATE LIMITED has partnered with IQApex Labs providing strategic guidance and investment support to accelerate technology initiatives.",
  },
];

const Funders = () => {
  return (
    <>
      <Navbar />

      <section className="funders-section" aria-labelledby="funders-heading">
        <header className="funders-header">
          <h2 id="funders-heading">Our Funders</h2>
          <p>
            We are proud to be supported by visionary institutions, government
            initiatives, and private investors who believe in our mission to
            build cutting-edge technology solutions for the future.
          </p>
        </header>

        <div className="funders-grid">
          {funders.map((funder, index) => (
            <article key={index} className="funder-card">
              <h3>{funder.name}</h3>
              <p>
                <strong>Type:</strong> {funder.type}
              </p>
              <p>
                <strong>Year:</strong> {funder.date}
              </p>
              <p className="funder-description">{funder.description}</p>
            </article>
          ))}
        </div>
      </section>
    </>
  );
};

export default Funders;
